<template>
  <div id="form-builder-code-editor-nxzzho">
    <b-form-textarea id="form-builder-code-editor-ne6fvd" v-model="codeComputed" rows="20"></b-form-textarea>
    <div id="form-builder-code-editor-i48zx7" class="d-flex justify-content-end">
      <small id="form-builder-code-editor-bqvq88" class="text-primary hover-pointer mt-1" @click="modalShown = true">
        Show Advanced Editor
      </small>
    </div>
    <b-modal id="form-builder-code-editor-r4gd4k"
      modal-class="code-editor-modal"
      v-model="modalShown"
      title="Code Editor"
      centered
      size="xl"
      no-close-on-backdrop
      header-bg-variant="primary"
      header-text-variant="white"
      header-class="p-0 d-block shadow-form bg-purple"
      footer-class="bg-extra-light-gray shadow-form"
      hide-footer
      @shown="showCodeMirror = true"
      @hidden="showCodeMirror = false"
    >
      <template v-slot:modal-header>
        <div id="form-builder-code-editor-hr2lj9"
          class="w-100 d-flex flex-row justify-content-between align-items-center"
          style="padding: 13px 20px;"
        >
          <div id="form-builder-code-editor-j9wmy2">
            <h5 id="form-builder-code-editor-mb78jl" class="modal-title font-weight-bold">Code Editor</h5>
          </div>
          <button id="form-builder-code-editor-bq17r3"
            type="button"
            aria-label="Close"
            class="close text-white"
            style="opacity:1 !important"
            @click="closeModal"
          >
            ×
          </button>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div id="form-builder-code-editor-9hnuq9"
          class="d-flex flex-row justify-content-end align-items-center w-100"
        >
          <div id="form-builder-code-editor-zw3hhb" class="mt-1">
            <b-button id="form-builder-code-editor-8fuf1e" @click="closeModal" variant="secondary">Close</b-button>
          </div>
        </div>
      </template>
      <div id="form-builder-code-editor-o5oqbt" class="h-100">
        <codemirror id="form-builder-code-editor-ssow8d"
          v-if="showCodeMirror"
          v-model="codeComputed"
          :options="cmOptions"
        ></codemirror>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "FormBuilderCodeEditor",
  props: ["value"],
  data() {
    return {
      modalShown: false,
      showCodeMirror: false,
      cmOptions: {
        tabSize: 4,
        mode: {
          name: "javascript",
          json: true
        },
        theme: "base16-dark",
        lineNumbers: true,
        line: true
      },
      code: "const a = 10"
    };
  },
  methods: {
    closeModal() {
      this.modalShown = false;
    }
  },
  computed: {
    ...mapGetters("layout", ["isTechStaff"]),
     ...mapState("layout", {
      advancedOptions: state => state.advancedOptions
    }),
    codeComputed: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (!this.isTechStaff && !this.advancedOptions) {
          newValue = newValue.replace("{{","").replace("}}","");
        }
        this.$emit("input", newValue);
      }
    }
  }
};
</script>
<style>
.code-editor-modal .shadow-footer-sm {
  box-shadow: 0px -8px 5px -7px rgb(0 0 0 / 8%);
}
.shadow-form {
  box-shadow: 0px 0px 14px -2px rgba(0, 0, 0, 0.5);
}
.code-editor-modal .modal-body {
  height: 85vh;
  overflow-y: auto;
}
.code-editor-modal .CodeMirror {
  height: 82vh !important;
}
</style>
